module.exports = __webpack_public_path__ + "img/swords.96ccb851.svg";